import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGTContext, GTProvider } from '../GTContext';

const Div = styled.div<{ $itemHeight: number }>`
  outline: 1px solid ${({ theme }) => theme.colors.stroke};
  background: ${({ theme }) => theme.colors.cultured};
  height: ${({ $itemHeight }) => $itemHeight}px;
  width: 100%;
  display: flex;
  align-items: center;

  tr[data-expanded='true'] & {
    margin-bottom: 1px;
  }

  .cydea-select {
    min-width: 0 !important;
    width: 100% !important;
    height: 100%;
  }
  .cydea-select__control {
    height: 100% !important;
    min-height: unset !important;
    border: none !important;
  }
  .cydea-select__value-container {
    padding: 0 14px !important;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    height: ${({ $itemHeight }) => $itemHeight * 0.8}px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: ${({ $itemHeight }) => $itemHeight * 0.6}px;
  }
`;

interface GTCInlineWrapperProps {
  children: React.ReactNode;
}

export const GTCInlineWrapper: React.FC<GTCInlineWrapperProps> = ({ children }) => {
  const { itemHeight } = useGTContext();
  const [portalTarget] = useState(() => document.createElement('div'));

  useEffect(() => {
    document.body.appendChild(portalTarget);
    return () => {
      document.body.removeChild(portalTarget);
    };
  }, [portalTarget]);

  return (
    <GTProvider value={{ itemHeight, portalTarget }}>
      <Div $itemHeight={itemHeight} onClick={(e) => e.stopPropagation()} className="gt-inline-wrapper">
        {children}
      </Div>
    </GTProvider>
  );
};
